module.exports = __webpack_public_path__ + "static/img/indexVersion04.03168a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexVersion04.jpg
// module id = 7TEO
// module chunks = 3